import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { Actions, Getters, Mutations, ModalIframeState } from '@/interfaces/store/modalIframe'
import { RootState } from '@/interfaces/store/root'
import ModalIframeOptions from '@/interfaces/modal-iframe-options'

export const state: ModalIframeState = {
  isModalIframeActive: false,
  modalOptionsIframe: undefined
}

export const getters: GetterTree<ModalIframeState, RootState> & Getters = {}
export const actions: ActionTree<ModalIframeState, RootState> & Actions = {}

export const mutations: MutationTree<ModalIframeState> & Mutations = {
  updateModalIframeActive(state: ModalIframeState, isModalIframeActive: boolean) {
    state.isModalIframeActive = isModalIframeActive
  },
  updateModalOptionsIframe(state: ModalIframeState, modalOption: ModalIframeOptions) {
    state.modalOptionsIframe = modalOption
  }
}

export const store: Module<ModalIframeState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
